import React, { useState } from "react";
import * as Mui from "@mui/material";
import { makeStyles } from "tss-react/mui";
import moment from "moment";
import { Task } from "model/task";
import { useSelector } from "react-redux";
import { RootState, useAppThunkDispatch } from "redux/store";
import { getAgentById, getLeadById, getUser } from "redux/selector";
import { updateTask } from "redux/slice/tasks";
import { TaskStatus } from "type/task-status";
import { agentTasksDev } from "shared/env";
import { AppCard } from "component/shared/app-card";
import { styles } from "./style";
import { TaskCardContent } from "./task-card-content";
import { DeleteTaskDialog } from "./delete-task-dialog";

interface Props {
	task: Task;
	onClick: () => void;
}

const useStyles = makeStyles()(styles);

export const TaskCard: React.FC<Props> = ({ task, onClick }) => {
	const { classes } = useStyles();
	const theme = Mui.useTheme();
	const dispatch = useAppThunkDispatch();

	const [showDeleteTaskDialog, setShowDeleteTaskDialog] = useState(false);

	const lead = useSelector((state: RootState) => getLeadById(state, task.leadId));
	const agent = useSelector((state: RootState) => getAgentById(state, task.agentId));
	const user = useSelector(getUser);
	const assigner = useSelector((state: RootState) => getAgentById(state, task.creatorId));

	const handleToggleCheckbox = () => {
		const status = task.status.active ? TaskStatus.COMPLETE : TaskStatus.ACTIVE;
		dispatch(updateTask({ task: { ...task, status } }));
	};

	const handleTogglePriority = () => {
		dispatch(updateTask({ task: { ...task, priority: !task.priority } }));
	};

	const handleDeleteTask = () => {
		dispatch(updateTask({ task: { ...task, status: TaskStatus.DELETED } }));
		setShowDeleteTaskDialog(false);
	};

	const checked = !task.status.active;
	const disabled = !user.admin && task.creatorId !== user.agentId;
	const ownsTask = task.creatorId === user.agentId;

	return (
		<>
			<DeleteTaskDialog
				open={showDeleteTaskDialog}
				onClose={() => setShowDeleteTaskDialog(false)}
				onConfirm={handleDeleteTask}
			/>
			<AppCard className={classes.card}>
				<Mui.CardContent className={classes.cardContent}>
					<TaskCardContent
						task={task}
						lead={lead}
						agent={agent}
						user={user}
						assigner={assigner}
						ownsTask={ownsTask}
						checked={checked}
						disabled={disabled}
						theme={theme}
						classes={classes}
						onToggleCheckbox={handleToggleCheckbox}
						onTogglePriority={handleTogglePriority}
						onDelete={() => setShowDeleteTaskDialog(true)}
						onEdit={onClick}
					/>
				</Mui.CardContent>
			</AppCard>
		</>
	);
};
